import { useMemo } from "react";
import { useSyncedResource } from "hooks/useSyncedResource.hook";
import * as SCOPE from "services/sync/scope";
import useInfrastructure from "hooks/useInfrastructure.hook";
import * as eventsSync from "services/sync/resources/chat/events.sync";

export function useChatEvents({ enabled = true, lineId, chatId } = {}) {
  const { syncEngine, repositories } = useInfrastructure();
  const repository = repositories.events;
  
  enabled = enabled && !!lineId && !!chatId;
  const syncParams = useMemo(() => ({ lineId, chatId }), [lineId, chatId]);
  const key = useMemo(() => `(lineId:${lineId})-(chatId:${chatId})`, [lineId, chatId]);
  const scope = SCOPE.CHAT.EVENTS;

  return useSyncedResource({
    enabled,
    scope,
    key,
    cacheFn: ({ scope, key }) => repository.getFromCache(scope, key, () => repository.getByLineIdChatId(lineId, chatId)),
    syncParams,
    syncFn: eventsSync.forConversation,
    syncEngine,
    repository,
    repositories,
    deps: [lineId, chatId]
  });
}